// extracted by mini-css-extract-plugin
export default {"pagination__body":"TBody_pagination__body__gJPU0","tableSettings":"TBody_tableSettings__2DGz1"};